import PropTypes from 'prop-types'
import React from 'react'
import { navigateTo } from '../../store/history/history.actions'
import ActionButton from '../genericComponents/buttons/ActionButton'
import { useAction } from '../utils/react-redux'
import useEventCallback from '../utils/useEventCallback'

export default function NavButton({ to, children, className, href, tagData }) {
  const execNavigateTo = useAction(navigateTo)
  const onClick = useEventCallback(() => {
    execNavigateTo(to)
  }, [execNavigateTo])

  return (
    <ActionButton className={className} onClick={onClick} href={href} noNavigate tagData={tagData}>
      {children}
    </ActionButton>
  )
}

NavButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  to: PropTypes.shape({
    route: PropTypes.string,
    fullRoute: PropTypes.string,
    routeOptions: PropTypes.object,
    selectedStoreState: PropTypes.object
  }),
  tagData: PropTypes.shape({
    tagInfo: PropTypes.object,
    type: PropTypes.string
  })
}
